import {
  IFormJBPHPContactChangeRequest,
  IFormJBPHPContactRoles,
} from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { guid } from 'core/classes/helpers/GuidHelper'
import { Crud } from 'core/types'

interface ISaveContactChangeRequestResult {
  hasDuplicate: boolean
  newRole: any | null
}

interface ISaveContactChangeRequest {
  resetCrudStorage: () => void
  newRequest: IFormJBPHPContactChangeRequest
  getContactsByEmail: (email: string) => Promise<IFormJBPHPContactChangeRequest[]>
  jbpHpContactChangeRequestCrud: Crud<IFormJBPHPContactChangeRequest, any>
  fetchPartnerRoles: (value: boolean) => Promise<IFormJBPHPContactRoles[]>
  isUseCrudClone?: boolean
}

export const saveHPContactChangeRequest = async ({
  newRequest,
  resetCrudStorage,
  getContactsByEmail,
  jbpHpContactChangeRequestCrud,
  fetchPartnerRoles,
  isUseCrudClone,
}: ISaveContactChangeRequest): Promise<ISaveContactChangeRequestResult> => {
  const crud = isUseCrudClone
    ? jbpHpContactChangeRequestCrud.clone()
    : jbpHpContactChangeRequestCrud
  if (newRequest) {
    if (!newRequest.TicketId || newRequest.TicketId === -1) {
      const isRequestActionAdd = newRequest.RequestAction === 'Add'
      if (isRequestActionAdd) {
        if (newRequest.Email) {
          const items = await getContactsByEmail(newRequest.Email)

          if (items.length > 0) {
            return { hasDuplicate: true, newRole: null }
          }
        }
      }

      newRequest = {
        ...newRequest,
        EntryId: -1,
        Status: newRequest.TicketStatus,
        Action: newRequest.RequestAction,
        SignId: newRequest.SignId || `new-${guid()}`,
      }

      await crud.create({ formId: '1217', code: 'jbp-hp-contact-change-request-1217' }, [
        newRequest,
      ])
      resetCrudStorage()
    } else {
      newRequest = {
        ...newRequest,
        EntryId: newRequest.TicketId,
        Status: newRequest.TicketStatus,
        Action: newRequest.RequestAction,
      }

      await crud.update({ formId: '1217', code: 'jbp-hp-contact-change-request-1217' }, [
        newRequest,
      ])
      resetCrudStorage()
    }
  }

  const roles = await fetchPartnerRoles(true)
  const newRole = roles.find((it) => it.Roles === newRequest.Roles)

  return { hasDuplicate: false, newRole }
}
